import { render, staticRenderFns } from "./s1-1.vue?vue&type=template&id=0fbe234a&scoped=true&"
import script from "./s1-1.vue?vue&type=script&lang=js&"
export * from "./s1-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe234a",
  null
  
)

export default component.exports